import { Icon, MenuItem, useTheme } from '@web-chat-core/ui-kit';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { ModalName } from 'features/Modals/ModalProvider';
import { useModal } from 'useCase/modal/useModal';
import { useCanSeeCallSettings } from 'features/CallSettings/hooks/useCanSeeCallSettings';

export const CallSettingsMenuItem = observer(() => {
    const theme = useTheme();
    const { t } = useTranslation();
    const { openModal } = useModal();
    const isCanSeeCallSettings = useCanSeeCallSettings();

    if (!isCanSeeCallSettings) {
        return null;
    }

    return (
        <MenuItem id="call-settings-menu-item" onClick={() => openModal(ModalName.CALL_SETTINGS)}>
            <Icon icon="icLock" color={theme.root.colors.basicColors['60%']} size={24} />
            {t('vks_request_call_settings')}
        </MenuItem>
    );
});
